import Vue from 'vue'
import App from './App'
import router from './router'
import YDUI from 'vue-ydui'
import 'vue-ydui/dist/ydui.px.css'
import './global/css/styles.css'
import './global/css/style.css'
import './global/css/font-awesome/css/font-awesome.min.css'
import API from './api/API'
import ZJF from './api/ZJF'
import Helper from './global/js/helper'
import MemberInfo from './global/js/memberinfo'
import Common from './global/js/common'
import VueClipboard from 'vue-clipboard2'
import publictop from './components/public/publictop.vue'
import header from './components/public/header.vue'
import publicnav from './components/public/publicnav.vue'
import footer from './components/public/footer.vue'
import echarts from 'echarts'
import HrefRouter from './global/js/mob_router'
import SIdentify from './components/tianmao/identify'
import ElementUI  from 'element-ui'
import '../static/theme-#FF2D51/index.css';
import moment from 'moment'
import cookie from 'vue-cookie'
import adv from './global/js/adv'
import VueMeta from 'vue-meta'
import './common-loader'


Vue.use(VueMeta)
Vue.use(SIdentify)
Vue.component('s-identify',SIdentify);
Vue.prototype.$Api = new API();
Vue.prototype.$ZJF = new ZJF();
Vue.prototype.MemberInfo=MemberInfo;
Vue.prototype.Helper=Helper;
Vue.prototype.Common=Common;
Vue.prototype.adv=adv;
Vue.prototype.$HrefRouter=HrefRouter;
Vue.prototype.moment=moment;
Vue.prototype.$cookie = cookie;
Vue.config.productionTip = false;

Vue.use(YDUI);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.component('publictop',publictop);
Vue.component('myheader',header);
Vue.component('publicnav',publicnav);
Vue.component('myfooter',footer);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js